import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, debounceTime } from 'rxjs';
import { AtsResponsiveService } from '../services/responsive.service';

@UntilDestroy()
@Directive({
    selector: '[atsResponsive]',
    standalone: false
})
export class ResponsiveDirective implements OnInit {
	@Input() skipUpdateOnStart: boolean = false;
	@Input() watcher$!: Observable<any>;
	width: any;
	classes!: string[];
	allClasses = ['gt-xs', 'gt-sm', 'gt-md', 'gt-lg', 'xs', 'sm', 'md', 'lg', 'xl', 'lt-sm', 'lt-md', 'lt-lg', 'lt-xl'];

	constructor(
		private readonly responsiveService: AtsResponsiveService,
		private readonly elementRef: ElementRef,
		private readonly renderer: Renderer2
	) {}

	ngOnInit(): void {
		if (!this.skipUpdateOnStart) this.updateWidth();

		this.responsiveService.windowResize$.pipe(untilDestroyed(this)).subscribe(() => {
			this.updateWidth();
		});

		if (this.watcher$) {
			this.watcher$.pipe(debounceTime(300), untilDestroyed(this)).subscribe(() => {
				this.updateWidth();
			});
		}
	}

	updateWidth(): void {
		this.width = this.elementRef.nativeElement.offsetWidth;
		this.classes = [];
		if (this.width < 599) {
			this.classes = ['xs', 'lt-sm', 'lt-md', 'lt-lg', 'lt-xl'];
		} else if (this.width < 959) {
			this.classes = ['gt-xs', 'sm', 'lt-md', 'lt-lg', 'lt-xl'];
		} else if (this.width < 1279) {
			this.classes = ['gt-xs', 'gt-sm', 'md', 'lt-lg', 'lt-xl'];
		} else if (this.width < 1919) {
			this.classes = ['gt-xs', 'gt-sm', 'gt-md', 'lg', 'lt-xl'];
		} else {
			this.classes = ['gt-xs', 'gt-sm', 'gt-md', 'gt-lg', 'xl'];
		}

		this.allClasses.forEach(cls => {
			this.renderer.removeClass(this.elementRef.nativeElement, cls);
			if (this.classes.includes(cls)) {
				this.renderer.addClass(this.elementRef.nativeElement, cls);
			}
		});
	}
}
